import { render, staticRenderFns } from "./Kelompok.vue?vue&type=template&id=1fb55230"
import script from "./Kelompok.vue?vue&type=script&lang=js"
export * from "./Kelompok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports